import { type IIdentifierProvider } from 'app/model/services/identifier/IIdentifierProvider';
import { generateIdentity, type Named } from 'shell-models-lib';
import { type IResourceBase } from 'app/shared/utils/resourcefiles.utils';

export class AzureIdentifierProvider implements IIdentifierProvider {
    public generateIdentifierFromResource(resource: IResourceBase): string {
        return generateIdentity(resource.type, resource.name);
    }

    public getUniqueKeyFromNamed(named: Named): string {
        return named.name;
    }

    public getUniqueKeyFromResource(resource: Partial<Record<'name' | 'objectId', string>>): string {
        return resource.name;
    }

    public generateResource(type: string, name: string): IResourceBase {
        return { type, name };
    }
}
